import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiConnectCaller";
import { globalHistory } from "./../../history";

export const GET_EXTENSION_API_CONNECT = "GET_EXTENSION_API_CONNECT";
export const GET_EXTENSION_API_CONNECT_ERROR =
  "GET_EXTENSION_API_CONNECT_ERROR";
export const GET_EXTENSION_API_CONNECT_SUCCESS =
  "GET_EXTENSION_API_CONNECT_SUCCESS";

export const GET_EXTENSION_API_CONNECT_ONLINE =
  "GET_EXTENSION_API_CONNECT_ONLINE";
export const GET_EXTENSION_API_CONNECT_ONLINE_ERROR =
  "GET_EXTENSION_API_CONNECT_ONLINE_ERROR";
export const GET_EXTENSION_API_CONNECT_ONLINE_SUCCESS =
  "GET_EXTENSION_API_CONNECT_ONLINE_SUCCESS";

export const CHANGE_EXTENSION_API_CONNECT = "CHANGE_EXTENSION_API_CONNECT";
export const CHANGE_EXTENSION_API_CONNECT_SUCCESS =
  "CHANGE_EXTENSION_API_CONNECT_SUCCESS";
export const CHANGE_EXTENSION_API_CONNECT_ERROR =
  "CHANGE_EXTENSION_API_CONNECT_ERROR";

export const CREATE_EXTENSION_API_CONNECT = "CREATE_EXTENSION_API_CONNECT";
export const CREATE_EXTENSION_API_CONNECT_SUCCESS =
  "CREATE_EXTENSION_API_CONNECT_SUCCESS";
export const CREATE_EXTENSION_API_CONNECT_ERROR =
  "CREATE_EXTENSION_API_CONNECT_ERROR";

export const DELETE_EXTENSION_API_CONNECT = "DELETE_EXTENSION_API_CONNECT";
export const DELETE_EXTENSION_API_CONNECT_SUCCESS =
  "DELETE_EXTENSION_API_CONNECT_SUCCESS";
export const DELETE_EXTENSION_API_CONNECT_ERROR =
  "DELETE_EXTENSION_API_CONNECT_ERROR";

/**
 * Reducer
 */

const initialState = {
  extensions: [],
  extensionsOnline: [],
  extension: {},
  error: false,
  loading: false,
};

export const extensionsReducer = (state = initialState, action) => {
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //     console.log(action)
  // }
  switch (action.type) {
    case GET_EXTENSION_API_CONNECT:
      return {
        ...state,
      };
    case GET_EXTENSION_API_CONNECT_SUCCESS:
      return {
        ...state,
        extensions: action.payload.data,
      };
    case GET_EXTENSION_API_CONNECT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //get extension online

    case GET_EXTENSION_API_CONNECT_ONLINE:
      return {
        ...state,
      };
    case GET_EXTENSION_API_CONNECT_ONLINE_SUCCESS:
      return {
        ...state,
        extensionsOnline: action.payload.data.items,
        error: false,
      };
    case GET_EXTENSION_API_CONNECT_ONLINE_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //Change

    case CHANGE_EXTENSION_API_CONNECT:
      return {
        ...state,
        loading: true,
        extension: {},
      };

    case CHANGE_EXTENSION_API_CONNECT_SUCCESS: {
      const newData = state.extensions.items.map((b) => {
        if (b.id == action.data.id) {
          b.password = action.data.password;
          b.phoneId = action.data.phoneId;
          b.caller = action.data.caller;
        }
        return b;
      });
      return {
        ...state,
        newData,
        loading: false,
      };
    }

    case CHANGE_EXTENSION_API_CONNECT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    //delete

    case DELETE_EXTENSION_API_CONNECT:
      return {
        ...state,
      };

    case DELETE_EXTENSION_API_CONNECT_SUCCESS: {
      const newExtension = state.extensions.items.filter((item) => {
        return item.id !== action.data.id;
      });
      return {
        ...state,
        newExtension,
      };
    }

    case DELETE_EXTENSION_API_CONNECT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    // create

    case CREATE_EXTENSION_API_CONNECT:
      return {
        ...state,
      };

    case CREATE_EXTENSION_API_CONNECT_SUCCESS:
      return {
        ...state,
        extension: action.payload.data,
      };

    case CREATE_EXTENSION_API_CONNECT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Action
 */

export const getExtensionApiConnectAction = () => ({
  type: GET_EXTENSION_API_CONNECT,
});

export const changeExtensionAction = (id, caller, password, phoneId) => ({
  type: CHANGE_EXTENSION_API_CONNECT,
  data: {
    id,
    caller,
    password,
    phoneId,
  },
});

export const createAExtension = () => ({
  type: CREATE_EXTENSION_API_CONNECT,
  data: {},
});

export const deleteAExtension = (id) => ({
  type: DELETE_EXTENSION_API_CONNECT,
  data: {
    id,
  },
});

export const getExtensionApiConnectOnline = () => ({
  type: GET_EXTENSION_API_CONNECT_ONLINE,
});

export const mapActionsExtensionToProps = (dispatch) => {
  return bindActionCreators(
    {
      getExtensionApiConnectAction,
      changeExtensionAction,
      createAExtension,
      deleteAExtension,
      getExtensionApiConnectOnline,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getExtensionApiConnectsApi = () => {
  return apiCaller.get(`${process.env.REACT_APP_API_CONNECT}/extensions`);
};

const putExtensionApi = (id, caller, password, phoneId) => {
  return apiCaller.put(
    `${process.env.REACT_APP_API_CONNECT}/extensions/${id}`,
    {
      caller,
      password,
      phoneId,
    }
  );
};

const createAExtensionApi = () => {
  return apiCaller.post(`${process.env.REACT_APP_API_CONNECT}/extensions`);
};

const getExtensionApiConnectOnlineApi = () => {
  return apiCaller.get(
    `${process.env.REACT_APP_API_CONNECT}/extensions/online`
  );
};

const deleteAExtensionApi = (id) => {
  return apiCaller.del(`${process.env.REACT_APP_API_CONNECT}/extensions/${id}`);
};
/**
 * sagas
 */

export const getExtensionApiConnectFlow = function* () {
  while (true) {
    yield take(GET_EXTENSION_API_CONNECT);
    try {
      const res = yield call(getExtensionApiConnectsApi);
      yield put({
        type: GET_EXTENSION_API_CONNECT_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_EXTENSION_API_CONNECT_ERROR, error });
    }
  }
};

export const putChangeExtensionFlow = function* () {
  while (true) {
    const action = yield take(CHANGE_EXTENSION_API_CONNECT);
    try {
      const res = yield call(
        putExtensionApi,
        action.data.id,
        action.data.caller,
        action.data.password,
        action.data.phoneId
      );
      yield put({
        type: CHANGE_EXTENSION_API_CONNECT_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
      const history = globalHistory();
      history.push("/extensions");
    } catch (error) {
      yield put({ type: CHANGE_EXTENSION_API_CONNECT_ERROR, error });
    }
  }
};

export const getExtensionApiConnectOnlineFlow = function* () {
  while (true) {
    yield take(GET_EXTENSION_API_CONNECT_ONLINE);
    try {
      const res = yield call(getExtensionApiConnectOnlineApi);
      yield put({
        type: GET_EXTENSION_API_CONNECT_ONLINE_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_EXTENSION_API_CONNECT_ONLINE_ERROR, error });
    }
  }
};

export const createAExtensionFlow = function* () {
  while (true) {
    const action = yield take(CREATE_EXTENSION_API_CONNECT);
    try {
      const res = yield call(createAExtensionApi, { ...action.data });
      yield put({
        type: CREATE_EXTENSION_API_CONNECT_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: CREATE_EXTENSION_API_CONNECT_ERROR, error });
    }
  }
};

export const deleteAExtensionFlow = function* () {
  while (true) {
    const action = yield take(DELETE_EXTENSION_API_CONNECT);
    try {
      const res = yield call(deleteAExtensionApi, action.data.id);
      yield put({
        type: DELETE_EXTENSION_API_CONNECT_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: DELETE_EXTENSION_API_CONNECT_ERROR, error });
    }
  }
};
